// The skills library: the list, a skill's editor, its files and their path rules.
import { plural } from "../../helpers";

const p = plural("en");

export default {
  title: "Skills",
  new: "New skill",
  newSubtitle: "It starts with a SKILL.md you edit next",
  create: "Create skill",
  search: "Search skills",
  searchPlaceholder: "Search by name, slug or description",
  loadError: "Could not load the skills",
  nothingMatches: "Nothing matches",
  noMatch: (q: string) => `No skill matches “${q}”.`,
  empty: "No skills yet",
  emptyHelp:
    "A skill is a folder of instructions (SKILL.md and any files it refers to) that workflow steps use. Create one and attach it to a workflow.",
  columns: { name: "Skill", description: "Description", files: "Files", usedBy: "Used by", status: "Status" },
  versions: (n: number) => p(n, { one: "# version", other: "# versions" }),
  active: "Active",
  archived: "Archived",
  open: (name: string) => `Open ${name}`,
  created: (name: string) => `Created ${name}`,
  editor: {
    loadError: "Could not load the skill",
    loading: "Loading the skill…",
    usedBy: (n: number) => p(n, { one: "Used by # workflow version", other: "Used by # workflow versions" }),
    archive: "Archive",
    restore: "Restore",
    saved: (name: string) => `Saved ${name}`,
    archivedToast: (name: string) => `Archived ${name}`,
    restoredToast: (name: string) => `Restored ${name}`,
    filesSaved: "Saved the files",
    details: "Details",
    saveDetails: "Save details",
    noDescription: "No description.",
  },
  form: {
    label: "Skill details",
    name: "Name",
    slug: "Slug",
    slugHint: (dir: string) => `Unique; the skill's directory: ${dir}`,
    description: "Description",
    descriptionPlaceholder: "When the agent should use it; a new skill's SKILL.md front matter starts with it",
    notSaved: "Not saved",
  },
  files: {
    label: "Skill files",
    title: "Files",
    readOnly: "Read only.",
    renameTo: "Rename to",
    rename: (path: string) => `Rename ${path}`,
    delete: (path: string) => `Delete ${path}`,
    content: (path: string) => `Content of ${path}`,
    preview: "Preview",
    edit: "Edit",
    skillMdHint: "Claude Code reads the front matter: name and description say when to use the skill.",
    tooBig: "A file is over 256 KB.",
    save: "Save files",
    saved: "Saved",
    add: "Add a file",
    newPath: "New file path",
    addButton: "Add",
    frontMatter: "Front matter",
    nothingToPreview: "Nothing to preview.",
  },
  path: {
    empty: "Give the file a path.",
    tooLong: "At most 200 characters.",
    characters: "Only letters, digits, '.', '_', '/' and '-'.",
    segments: "Relative, without empty, '.' or '..' parts.",
    taken: "A file has this path.",
    renameSkillMd: "SKILL.md is required; it cannot be renamed.",
    deleteSkillMd: "SKILL.md is required; it cannot be deleted.",
  },
};
